export default function ErrorPage() {

    return (
        <div>
            Error page
        </div>
    )
}